// import design from '@/config/design';
export default {
  styles: {}
};
export const selectionConfig = {};